import {Container, Simbol, Fertilidade, Selo, Relacao, RegraDia, RelacaoR, ViewPosition} from './styles';

interface DataSimbol {
    comp: string,
    regra?: number,
    selo?: number,
    click?: any,
    edit: boolean
    impresso?: boolean
}

interface DataSquema {
    regra?: any;
    regracount?: any;
    fertilidade?: any;
    relacao?: any;
    selo?: any;
    edit: boolean;
    click: () => void;
    impresso?: boolean
}

export function Simbols({ comp, regra = 1, selo = 0, click, edit, impresso = false} : DataSimbol){
    return(
        <Container edit={edit} fullSpace={comp === 'selo' && true}>
            { comp === 'selo' && !impresso && <Selo><div className={"cor regra"+regra}></div></Selo> }
            { comp === 'simbol' &&      <Simbol         onClick={edit ? () => click() : () => {}} selo={selo} temselo={selo > 0 || false}><div className={"regra"+regra}></div></Simbol> }
            { comp === 'fertilidade' && <Fertilidade    onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Fertilidade> }
            { comp === 'relacao' &&     <Relacao        onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></Relacao> }
            { comp === 'regradia' &&    <RegraDia       onClick={edit ? () => click() : () => {}}><div className={"regra"+regra}></div></RegraDia> }
            { comp === 'relacaoR' &&    <RelacaoR>R</RelacaoR> }
        </Container>
    )
}

export function SquemaSimbols({ regra, regracount, fertilidade, relacao, selo, edit, click, impresso = false }: DataSquema) {
    const r   = Number(regra)       || 0;
    const rc  = Number(regracount)  || 0;
    const f   = Number(fertilidade) || 0;
    const rel = Number(relacao)     || 0;
    const s   = Number(selo)        || 0;

    const hasF     = f > 0;
    const hasRegra = r >= 1 && r <= 4;
    const hasCount = rc > 0;
    const hasR     = rel > 0;

    const hasAnything = hasF || hasRegra || hasCount || hasR;
    const handleClick = edit ? click : () => {};

    if (!hasAnything) {
        return (
            <>
                <Simbol onClick={handleClick} temselo={s > 0}>
                    <div className="regranull"></div>
                </Simbol>
                <Simbols comp="selo" regra={s} edit={false} click={() => {}} impresso={impresso} />
            </>
        );
    }

    // fertTop  → fertilidade presente: figura no topo, resto em linha abaixo
    // regraTop → regra + count + R (sem fertilidade): regra no topo, [R][count] abaixo
    // horizRow → tem R mas não hasRegra: tudo em linha horizontal, R por último/primeiro
    // vertStack→ padrão: regra em cima, count abaixo
    const schema =
        hasF                         ? 'fertTop'  :
        hasRegra && hasCount && hasR ? 'regraTop' :
        hasR && !hasRegra            ? 'horizRow' :
        'vertStack';

    const renderContent = () => {
        if (schema === 'vertStack') {
            return (
                <ViewPosition style={{ gap: '0px' }}>
                    {hasRegra && <Simbols comp="simbol"   regra={r}   selo={s} edit={edit} click={click} />}
                    {hasCount && <Simbols comp="simbol"   regra={rc}           edit={edit} click={click} />}
                    {hasR     && <Simbols comp="relacaoR" regra={rel}          edit={edit} click={click} />}
                </ViewPosition>
            );
        }

        if (schema === 'horizRow') {
            // regracount >= 7 = texto ("1"/"2"/"3") → R vem ANTES; símbolo vem ANTES caso contrário
            const rBeforeCount = hasCount && rc >= 7;
            return (
                <ViewPosition style={{ flexDirection: 'row', gap: '3px', alignItems: 'center' }}>
                    {rBeforeCount          && <Simbols comp="relacaoR" regra={rel} edit={edit} click={click} />}
                    {hasCount              && <Simbols comp="simbol"   regra={rc}  edit={edit} click={click} />}
                    {!rBeforeCount && hasR && <Simbols comp="relacaoR" regra={rel} edit={edit} click={click} />}
                </ViewPosition>
            );
        }

        if (schema === 'regraTop') {
            return (
                <ViewPosition style={{ flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', gap: '2px' }}>
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                        {hasRegra && <Simbols comp="simbol" regra={r} selo={s} edit={edit} click={click} />}
                    </div>
                    {hasR     && <Simbols comp="relacaoR" regra={rel} edit={edit} click={click} />}
                    {hasCount && <Simbols comp="simbol"   regra={rc}  edit={edit} click={click} />}
                </ViewPosition>
            );
        }

        // fertTop
        return (
            <ViewPosition style={{ flexWrap: 'wrap', flexDirection: 'row', justifyContent: 'center', alignContent: 'center', gap: '0px', columnGap: '4px', rowGap: 0 }}>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                    {hasF && <Simbols comp="fertilidade" regra={f} edit={edit} click={click} />}
                </div>      
                {hasRegra && <Simbols comp="simbol"   regra={r}   selo={s} edit={edit} click={click} />}
                {rc === 6 ? (
                    <>
                    {hasCount && <Simbols comp="simbol"   regra={rc}           edit={edit} click={click} />}                    
                    {hasR     && <Simbols comp="relacaoR" regra={rel}          edit={edit} click={click} />}
                    </>
                ) : (
                    <>
                    {hasR     && <Simbols comp="relacaoR" regra={rel}          edit={edit} click={click} />}
                    {hasCount && <Simbols comp="simbol"   regra={rc}           edit={edit} click={click} />}                    
                    </>
                )}          
            </ViewPosition>
        );
    };

    return (
        <>
            {renderContent()}
            {!impresso &&
                <Simbols comp="selo" regra={s} edit={false} click={() => {}} impresso={impresso} />
            }
        </>
    );
}
